import { useEffect, useState } from "react";
import {
  SmartAlert,
  SmartLoaderInterface,
  SmartTable,
  SmartTableNewInterface,
} from "soft_digi";
import { USER_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { showAlertAutoClose, showYesOrNoAlert } from "../../services/notifyService";
import { get, post } from "../../services/smartApiService";
import UsersForm from "./UsersForm";
import UserPassChange from "./UserPassChange";
import { checkInterSection } from "soft_digi/dist/services/FilterService";

const UsersTable = () => {
  const [tabData, setTabData] = useState([]);
  const { openModal, closeModal, setTitle,user } = useSiteContext();
      const is_admin = checkInterSection(user?.roles || [], ["ADMIN"]);
  // const { setTitle } = useSiteContext();
  useEffect(() => {
    setTitle("Trainers");
  }, []);

  const loadTableData = () => {
    let URL = USER_URLS.GET_ALL;
    const subscription = get(URL).subscribe((response) => {
      setTabData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    loadTableData();
  }, []);

  const openOfficesForm = (data: any) => {
    let options = {
      title: <>{data.ID ? "Trainer Update Form" : "Trainer Addition Form"}</>,
      content: <UsersForm loadTableData={loadTableData} dataIn={data} />,
      className: "sd-efl-modal",
      closeBody: false,
      width: 60,
    };
    openModal(options);
  };
  const openPasswordChangeForm = (id: any) => {
    let options = {
      title: "Password Change Form",
      //   content: <PasswordChangeForm id={id} />,
      className: "sd-efl-modal",
      closeBody: false,
      width: 60,
    };
    openModal(options);
  };
  const handleDelete = (rowData: any) => {
    console.log("Delete action for row:", rowData);
  };

  const deleteData = (id: any) => {
    const subscription = post(USER_URLS.DELETE, { id: id }).subscribe(
      (response) => {
        showAlertAutoClose("Deleted Successfully...", "success");
        closeModal();
        loadTableData();
        // setLoading(false);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  const openDeleteModal = (id: any) => {
    let alertProps: SmartLoaderInterface.SmartAlertInterface = {
      title: (
        <span className="has-text-danger">
          <i className="fa fa-check"></i> Trainer Deletion!
        </span>
      ),
      alertFunction: (option) => {
        if (option == "yes") {
          deleteData(id);
          SmartAlert.hide();
        }
      },
      content: (
        <p>
          Note: Do you wish to delete this Trainer? This action cannot be reverted
        </p>
      ),
      className: "custom-alert",
    };

    SmartAlert.show(alertProps);
  };

  const viewEditForm = (id: any) => {
    const subscription = post(USER_URLS.GET_ONE, { id: id }).subscribe(
      (response: any) => {
        openOfficesForm(response.data);
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  };

  const openViewDetails = (userData: any) => {
    let options = {
      title: "Trainer Details",
      //   content: <UsersTableView userData={userData} />,
      width: 60,
      className: "sd-efl-modal",
      closeBody: false,
    };
    openModal(options);
  };
  const openpassDetails = (_id: any) => {
    let options = {
      title: "Password Reset",
      content: <UserPassChange _id={_id} />,
      width: 60,
      className: "sd-efl-modal is-pointer",
      closeBody: false,
    };
    openModal(options);
  };
  const buttons = [
    // {
    //   label: "",
    //   type: "icon",
    //   leftIcon: "fa fa-eye",
    //   classList: ["smart-hims-table-view-icon"],
    //   onClick: (data: any) => {
    //     // openViewDetails(data);
    //   },
    // },
    {
      label: "",
      type: "icon",
      leftIcon: " fa-pencil-square",
      classList: ["smart-hims-table-edit-icon"],
      onClick: (data: any) => {
        viewEditForm(data["ID"]);
      },
        hideFunction: (data: any) => {
        return is_admin ? false : true;
      },
    },
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-trash",
      classList: ["smart-hims-table-delete-icon"],
      onClick: (data: any) => {
        openDeleteModal(data["ID"]);
      },
        hideFunction: (data: any) => {
        return is_admin ? false : true;
      },
    },
    {
      label: "",
      type: "icon",
      leftIcon: "fa fa-unlock",
      classList: ["smart-hims-table-view-icon"],
      onClick: (data: any) => {
        openpassDetails(data["ID"]);
      },
        hideFunction: (data: any) => {
        return is_admin ? false : true;
      },
    },
  ];
  const statusTags = [
    { value: 5, label: "Active", class: "is-primary" },
    { value: 10, label: "Inactive", class: "is-danger" },
  ];
  const RolesList = (data: any) => {
    return (
      <div className="tags ">
        {data?.roles?.map((user: any) => (
          <div key={user.value} className="tag is-success mx-1">
            {user.label}
          </div>
        ))}
      </div>
    );
  };
  const StatusUpdate = (id: number, status: number) => {
    const subscription = post(USER_URLS.STATUS_UPDATE, {
      id: id,
      active_status: status, 
    }).subscribe(() => {
      loadTableData(); 
    });
  
    return () => {
      subscription.unsubscribe();
    };
  };
  
  const updateStatus = (itemIn: any) => {
    let new_status: number = itemIn.active_status === 5 ? 10 : 5;
    let msg: string =
      new_status === 5
        ? "Do you wish to set the User as Active?"
        : "Do you wish to set the User as Inactive?";
  
    showYesOrNoAlert(
      msg,
      (selection: Selection) => updateStatusFinal(selection, itemIn, new_status),
      "info"
    );
  };
  
  const updateStatusFinal = (
    selection: any,
    itemIn: any,
    new_status: number
  ) => {
    if (selection === "yes") {
      StatusUpdate(itemIn.ID, new_status);
    }
  };
  
  const SwitchForm = (item: any) => {
    return (
      item.ID && (
        <div className="field">
          <input
            id={`switchExample_${item.ID}`}
            type="checkbox"
            name={`switchExample_${item.ID}`}
            className="switch is-small"
            checked={item.active_status === 5} 
            onChange={() => updateStatus(item)}
          />
          <label htmlFor={`switchExample_${item.ID}`}></label>
        </div>
      )
    );
  };
  
  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    // {
    //   title: "User ID",
    //   index: "euserid",
    //   width: "10",
    // },
    {
      title: "Name",
      index: "ename",
      width: "10",
    },
    {
      title: "Email",
      index: "emailid",
      width: "15",
    },
    {
      title: "Mobile Number",
      index: "mobile_no",
      width: "10",
    },
    {
      title: "Role",
      index: "roles",
      width: "20",
      valueFunction: RolesList,
    },

    ...(is_admin
    ? [
        {
          title: "Status",
          index: "status",
          valueFunction: SwitchForm,
          width: "10",
        },
      ]
    : []),
    // { title: "Status", index: "status", valueFunction: SwitchForm ,       width: "10",}, 
    // {
    //   title: "	Status",
    //   index: "active_status",
    //   width: "10",
    //   type: "tags",
    //   tags: statusTags,
    // },
    ...(is_admin?
      [
    {
      title: "Action",
      index: "action",
      type: "buttons",
      buttons: buttons,
      width: "10",
    },]
    :[] as any)
  ];

;
  const tableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-6",
      custom: <p className="is-size-4 has-text-weight-bold"></p>,
    },
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "JUSTIFY",
    },
    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: 
      [
        {
          type: "REFRESH",
          action: loadTableData,
        },

        
        {
          label: "Add",
          icon: "fa-plus",
          type: "CUSTOM",
          className: "smart-third-button",
          action: openOfficesForm,
        },
      ],
    },
  ];
    const UserTableTop: SmartTableNewInterface.SmartTableNewTopProps[] = [
    {
      type: "CUSTOM",
      widthClass: "is-6",
      custom: <p className="is-size-4 has-text-weight-bold"></p>,
    },
    {
      type: "SEARCH",
      widthClass: "is-4",
      align: "JUSTIFY",
    },
    {
      type: "BUTTONS",
      widthClass: "is-2",
      align: "CENTER",
      buttons: 
      [
        {
          type: "REFRESH",
          action: loadTableData,
        },

        
       
      ],
    },
  ];

  return (
    <>
      <div className="sd-efl-input">
        <SmartTable
          columns={columns}
          data={tabData}
          tableTop={is_admin? tableTop:UserTableTop}
          tableProps={{
            className: "is-hoverable is-bordered smart-hims-table",
            isResponsive: true,
            searchPlaceHolder: "Search",
          }}
          paginationProps={{
            pageSize: 10,
          }}
        />
      </div>
    </>
  );
};

export default UsersTable;
